import moment from 'moment';
import React from 'react';

import DebitCardIcon from '../../../../assets/svg_components/DebitCardIcon';
import InstallmentIcon from '../../../../assets/svg_components/InstallmentIcon';
import PayfiPrimaryLogo from '../../../../assets/svg_components/PayfiPrimaryLogo';
import RequestGuarateeIcon from '../../../../assets/svg_components/RequestGuarateeIcon';
import PaymentTabContainerStyles from './PaymentTabContainer.module.scss';
import PaymentTab from './_partials/PaymentTab';

interface IPaymentTabContainer {
  id: string;
  payload: any;
  address: string;
  loading: boolean;
}
const PaymentTabContainer = ({ id, payload, address, loading }: IPaymentTabContainer) => {
  const getCurrentYear = moment().year();

  const tabs = [
    {
      id: 1,
      icon: <DebitCardIcon />,
      title: 'One-time payment',
      link: `/payment-type/${id}/one-time-payment`,
      activeLink: [`/payment-type/${id}/one-time-payment`],
      type: 'one-time'
    },
    {
      id: 2,
      icon: <InstallmentIcon />,
      title: 'Instalment payment',
      link: `/payment-type/${id}/installment-payment`,
      activeLink: [`/payment-type/${id}/installment-payment`],
      type: 'installment'
    }
  ];

  return (
    <div className={PaymentTabContainerStyles.wrapper}>
      <div className={PaymentTabContainerStyles.wrapper__topContainer}>
        <div className={PaymentTabContainerStyles.wrapper__title}>
          <RequestGuarateeIcon fillColor="rgba(89, 65, 169, 1)" />
          <span>Return to payment</span>
        </div>
        <div className={PaymentTabContainerStyles.wrapper__subtitle}>Select payment method</div>
      </div>
      <div className={PaymentTabContainerStyles.wrapper__paymentTabs}>
        {tabs?.map((list) => (
          <PaymentTab
            title={list?.title}
            key={list?.id}
            icon={list?.icon}
            link={list?.link}
            activeLink={list?.activeLink}
            address={address}
            payload={payload}
            type={list?.type}
            loading={loading}
            id={id}
          />
        ))}
      </div>
      <div className={PaymentTabContainerStyles.wrapper__footer}>
        <div className={PaymentTabContainerStyles.wrapper__logo}>
          Powered by
          <span>
            <PayfiPrimaryLogo width="54px" height="20px" />
          </span>
        </div>
        <div className={PaymentTabContainerStyles.wrapper__copyRight}>
          Copyright © {getCurrentYear} Payfi Inc.
        </div>
      </div>
    </div>
  );
};

export default PaymentTabContainer;
